<template>
  <v-dialog v-model="show" persistent scrollable max-width="1000px">
    <v-card v-if="show">
      <v-card-title>
        <v-layout>
          <v-flex class="form-control">
            <input type="text" v-model="search" :placeholder="$t('Search')" />
          </v-flex>
          <v-flex v-if="!singleselect" class="text-xs-right">
            <v-btn :color="countSelected > 0 ? 'primary' : 'grey'" @click="clearAllPost" outline>{{
              $t('Select All Post')
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 300px">
        <v-tabs v-model="tab" color="white" :slider-color="$vuetify.theme.primary">
          <!-- <v-tab ripple :key="'published_post'" :href="'#published_post'">{{$t('Published post')}}</v-tab>

          <v-tab ripple :key="'schedule_post'" :href="'#schedule_post'">{{$t('Schedule post')}}</v-tab>
          <v-tab
            ripple
            :key="'ads_post'"
            :href="'#ads_post'"
          >{{$t('selected post')}} ({{selectedPosts.length}})</v-tab>-->

          <v-tabs-items touchless>
            <v-tab-item :key="'published_post'" touchless :value="'published_post'">
              <div style="padding: 15px 25px">
                <template v-if="loading">
                  <scale-loader
                    :color="$vuetify.theme.primary"
                    height="35px"
                    width="7px"
                  ></scale-loader>
                </template>
                <template v-else-if="filterPublishedPost.length > 0">
                  <div
                    class="z-border-red"
                    style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
                    v-for="(p, index) in filterPublishedPost"
                    :key="'published_post_' + index"
                    @click="selectedPublishedPost(p.id)"
                  >
                    <v-layout wrap>
                      <v-flex xs1 sm1>
                        <v-btn
                          fab
                          depressed
                          small
                          :outline="!p.selected"
                          color="primary"
                          class="extra-small ma-0"
                        >
                          <em class="fas fa-check" />
                        </v-btn>
                      </v-flex>
                      <v-flex xs11 sm11>
                        <div style="padding-left: 10px; word-break: break-all">
                          <a
                            :href="'https://www.facebook.com/' + p.id"
                            target="_blank"
                            rel="noopener noreferrer"
                            :title="p.name"
                            >{{ p.name | truncate(200) }}</a
                          >
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>

                  <div class="text-xs-center">
                    <v-btn
                      color="primary"
                      outline
                      v-if="hasMorePublishPost"
                      @click="getPublishedPost"
                      :loading="loadingPublishedPost"
                      >{{ $t('Next') }}</v-btn
                    >
                  </div>
                </template>
                <template v-else>
                  <div class="text-xs-center">{{ $t('No post') }}</div>
                </template>
              </div>
            </v-tab-item>
            <v-tab-item :key="'schedule_post'" touchless :value="'schedule_post'">
              <div style="padding: 15px 25px">
                <template v-if="loading">
                  <scale-loader
                    :color="$vuetify.theme.primary"
                    height="35px"
                    width="7px"
                  ></scale-loader>
                </template>
                <template v-else-if="filterSchedulePost.length > 0">
                  <div
                    class="z-border-red"
                    style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
                    v-for="(p, index) in filterSchedulePost"
                    :key="'schedule_post_' + index"
                    @click="selectedSchedulePost(p.id)"
                  >
                    <v-layout wrap>
                      <v-flex xs1 sm1>
                        <v-btn
                          fab
                          depressed
                          small
                          :outline="!p.selected"
                          color="primary"
                          class="extra-small ma-0"
                        >
                          <em class="fas fa-check" />
                        </v-btn>
                      </v-flex>
                      <v-flex xs11 sm11>
                        <div style="padding-left: 10px; word-break: break-all">
                          <a
                            :href="'https://www.facebook.com/' + p.id"
                            target="_blank"
                            rel="noopener noreferrer"
                            :title="p.name"
                            >{{ p.name | truncate(200) }}</a
                          >
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>

                  <div class="text-xs-center">
                    <v-btn
                      color="primary"
                      outline
                      v-if="hasMoreSchedulePost"
                      @click="getSchedulePost"
                      :loading="loadingSchedulePost"
                      >{{ $t('Next') }}</v-btn
                    >
                  </div>
                </template>
                <template v-else>
                  <div class="text-xs-center">{{ $t('No post') }}</div>
                </template>
              </div>
            </v-tab-item>
            <v-tab-item :key="'ads_post'" touchless :value="'ads_post'">
              <div style="padding: 15px 25px">
                <template v-if="loading">
                  <scale-loader
                    :color="$vuetify.theme.primary"
                    height="35px"
                    width="7px"
                  ></scale-loader>
                </template>
                <template v-else>
                  <template v-for="(post, index) in selectedPosts">
                    <div class="z-border-red mb-4 pa-2" :key="index">
                      <v-layout>
                        <v-flex class="primary--text pa-2">{{ post }}</v-flex>
                        <v-flex class="text-xs-right pa-2">
                          <v-btn
                            small
                            fab
                            outline
                            class="ma-0 extra-small"
                            color="primary"
                            @click="onDeletePost(post)"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>

                  <a href="javascript:void(0);" v-if="!isShow" @click="isShow = true">
                    <div class="add-conversation text-xs-center">
                      <em class="fa fa-plus middle" />
                      {{ $t('Add') }}
                    </div>
                  </a>
                  <v-layout v-else>
                    <v-flex>
                      <div class="form-control">
                        <input type="text" v-model="adsValue" placeholder="Ads ID" />
                      </div>
                    </v-flex>
                    <v-btn depressed color="primary" @click="onAddAdsPost">{{ $t('Add') }}</v-btn>
                  </v-layout>
                </template>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" outline @click="cancelPost">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="saveEditPost"
          >{{ $t('Select') }} {{ countSelected > 0 ? `(${countSelected})` : '' }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import { Promise } from 'q'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  props: ['value', 'show', 'singleselect'],
  components: {
    ModalDialog,
    ScaleLoader
  },
  data: function () {
    return {
      publishedPostOption: [],
      schedulePostOption: [],
      posts: '',
      search: '',
      tab: 'published_post',
      loading: false,
      nextPublishPost: null,
      hasMorePublishPost: true,
      nextSchedulePost: null,
      hasMoreSchedulePost: true,
      loadingPublishedPost: true,
      loadingSchedulePost: true,
      isShow: false,
      adsValue: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterPublishedPost: function () {
      var vm = this
      if (vm.search !== '') {
        return vm.publishedPostOption.filter(function (post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return this.publishedPostOption
    },
    filterSchedulePost: function () {
      var vm = this
      if (vm.search !== '') {
        return vm.schedulePostOption.filter(function (post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return this.schedulePostOption
    },
    countSelected: function () {
      var publishedPosts = this.publishedPostOption.filter(function (el) {
        return el.selected
      })
      var schedulePosts = this.schedulePostOption.filter(function (el) {
        return el.selected
      })
      return publishedPosts.length + schedulePosts.length
    },
    selectedPosts: {
      get: function () {
        var posts = []
        if (this.posts && this.posts != '' && this.posts != null) {
          posts = this.posts.split(',')
        }
        return posts
      },
      set: function (val) {
        this.posts = val
      }
    }
  },
  mounted: function () {
    var vm = this
    vm.posts = vm.value
    vm.cache_post = vm.value
    vm.loading = true
    vm.getPublishedPost().then(
      function () {
        vm.getSchedulePost().then(
          function () {
            vm.loading = false
          },
          function (e) {
            vm.loading = false
          }
        )
      },
      function (e) {
        vm.loading = false
      }
    )
  },
  methods: {
    clearAllPost: function () {
      var vm = this
      if (vm.publishedPostOption) {
        vm.publishedPostOption.map(function (post, index) {
          vm.publishedPostOption[index].selected = false
        })
      }
      if (vm.schedulePostOption) {
        vm.schedulePostOption.map(function (post, index) {
          vm.schedulePostOption[index].selected = false
        })
      }
      this.posts = ''
    },
    getPublishedPost: function () {
      return new Promise((resolve, reject) => {
        var vm = this
        vm.loadingPublishedPost = true

        api.getPublishedPost(vm.nextPublishPost).then(
          function (response) {
            if (response.paging && response.paging.next) {
              vm.nextPublishPost = response.paging.next
            } else {
              vm.hasMorePublishPost = false
            }
            if (response.data) {
              response.data.map(function (post, index) {
                if (post.message || post.story) {
                  vm.publishedPostOption.push({
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                } else {
                  vm.publishedPostOption.push({
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                }
              })
              vm.loadingPublishedPost = false
              resolve()
            }
          },
          function (e) {
            vm.loadingPublishedPost = false
            reject(e)
          }
        )
      })
    },
    getSchedulePost: function () {
      return new Promise((resolve, reject) => {
        var vm = this

        vm.loadingSchedulePost = true
        api.getSchedulePost(vm.nextSchedulePost).then(
          function (response) {
            if (response.paging && response.paging.next) {
              vm.nextSchedulePost = response.paging.next
            } else {
              vm.hasMoreSchedulePost = false
            }
            if (response.data) {
              response.data.map(function (post, index) {
                if (post.message || post.story) {
                  vm.schedulePostOption.push({
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                } else {
                  vm.schedulePostOption.push({
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                }
              })
              vm.loadingSchedulePost = false
              resolve()
            }
          },
          function (e) {
            vm.loadingSchedulePost = false
            reject(e)
          }
        )
      })
    },
    onDeletePost: function (id) {
      var vm = this
      var index = vm.selectedPosts.findIndex(function (el) {
        return el === id
      })

      if (index != -1) {
        vm.selectedPosts.splice(index, 1)
      }
      vm.$forceUpdate()
    },
    onAddAdsPost: function () {
      if (!this.adsValue && this.adsValue.trim() == '') {
        return false
      }
      this.selectedPosts.push(this.adsValue)
      this.isShow = false
    },
    selectedPublishedPost: function (id) {
      var vm = this
      vm.publishedPostOption.map(function (post, index) {
        if (post.id === id) {
          vm.publishedPostOption[index].selected = !vm.publishedPostOption[index].selected
          return false
        } else if (vm.singleselect) {
          vm.publishedPostOption[index].selected = false
        }
      })

      var index = vm.selectedPosts.findIndex(function (el) {
        return el === id
      })
      if (index == -1) {
        if (vm.singleselect) {
          vm.selectedPosts = []
          vm.selectedPosts.push(id)
        } else {
          vm.selectedPosts.push(id)
        }
      } else {
        vm.selectedPosts.splice(index, 1)
      }
    },
    selectedSchedulePost: function (id) {
      var vm = this
      vm.schedulePostOption.map(function (post, index) {
        if (post.id === id) {
          vm.schedulePostOption[index].selected = !vm.schedulePostOption[index].selected
          return false
        } else if (vm.singleselect) {
          vm.schedulePostOption[index].selected = false
        }
      })

      var index = vm.selectedPosts.findIndex(function (el) {
        return el === id
      })

      if (index == -1) {
        if (vm.singleselect) {
          vm.selectedPosts = id
        } else {
          vm.selectedPosts.push(id)
        }
      } else {
        vm.selectedPosts.splice(index, 1)
      }
    },
    saveEditPost: function () {
      var vm = this
      vm.$emit('input', vm.selectedPosts.join(','))
      vm.$emit(
        'update:postdata',
        vm.publishedPostOption.find((el) => el.id == vm.selectedPosts.join(','))
      )
      vm.$emit('close')
    },
    cancelPost: function () {
      var vm = this
      //   vm.post = vm.cache_post
      vm.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/live/IntentSelectPost.vue